import React from 'react'
import PropTypes from 'prop-types'
import FilterCategoryGroup from '../FilterCategoryGroup'
import { Text, Divider, Box } from 'pcln-design-system'
import SopqDetailsLearnMore from '@pcln/sopq-details-learn-more'

export const expressDealLearnMore = (sopqLearnMore, sopqProps) => (
  <Box pb={4} data-testid='SOPQ_DESCRIPTION_UNDER_CHECKBOXES'>
    <SopqDetailsLearnMore props={sopqProps} data-testid='SOPQ_DETAILS_LEARN_MORE' />
  </Box>
)

const FiltersSection = ({
  activeSearch,
  buttonIsGrayWithNoInput,
  categories,
  header,
  hideCloseIcon,
  largeCategoryHeader,
  priceGuidanceNewLabelStyle,
  showChip,
  showDivider,
  searchFilterFontSize,
  textCollapsed,
  textExpanded,
  showSearchIconButton,
  showLeftRail,
  sopqLearnMore,
  sopqProps,
  dealsDontMove,
}) => {
  if (!categories) return null
  return (
    <>
      {!largeCategoryHeader && showDivider && <Divider mb={3} mt={0} />}

      {!largeCategoryHeader && header && (
        <Text as='h2' fontSize={2} mb={2} mt={0} fontWeight='bold'>
          {header}
        </Text>
      )}

      {categories.map((category, index) => (
        <div key={`filter-category-${index}`}>
          {showLeftRail && index === 1 && dealsDontMove && expressDealLearnMore(sopqLearnMore, sopqProps)}
          <FilterCategoryGroup
            activeSearch={activeSearch}
            avgRetailPrice={category.avgRetailPrice}
            buttonIsGrayWithNoInput={buttonIsGrayWithNoInput}
            featuredFilters={category.featuredFilters}
            filterName={category.filterName}
            filters={category.filters}
            filterSummaryTitle={category.filterSummaryTitle}
            handleAfterChange={category.handleAfterChange}
            handleChange={category.handleChange}
            handleReset={category?.handleReset}
            handleSubmit={category.handleSubmit}
            hasParentCheckbox={category.hasParentCheckbox}
            hideCloseIcon={hideCloseIcon}
            hideFilterName={!!category.hideFilterName}
            hideLastPlus={category.hideLastPlus}
            includeDivider={category.includeDivider}
            includeSliderContent={category.includeSliderContent}
            includeSliderHeadline={category.includeSliderHeadline}
            isAccordion={category.isAccordion}
            isExpanded={category.isExpanded}
            isParentOptional={category.isParentOptional}
            itemsToShow={category.itemsToShow}
            key={`${category.type}-${index}`}
            largeCategoryHeader={largeCategoryHeader}
            markedValues={category.markedValues}
            priceGuidanceAllStarAvgPrice={category.priceGuidanceAllStarAvgPrice}
            priceGuidanceFilterData={category.priceGuidanceFilterData}
            priceGuidanceNewLabelStyle={priceGuidanceNewLabelStyle}
            scrollMode={category.scrollMode}
            searchFilterFontSize={searchFilterFontSize}
            sectionPb={category.sectionPb}
            shouldPadConsistently={category.shouldPadConsistently}
            showChip={category?.overrideChip ? false : showChip}
            showIncrementalSlider={category.showIncrementalSlider}
            showSearchIconButton={showSearchIconButton}
            showSliderInputs={category.showSliderInputs}
            sliderInputMaxLabel={category.sliderInputMaxLabel}
            sliderInputMinLabel={category.sliderInputMinLabel}
            stateless={category.stateless}
            textCollapsed={textCollapsed}
            textExpanded={textExpanded}
            title={category.filters.primaryLabel}
            type={category.type}
            useInternalState={category?.useInternalState}
            wrapLabel={category.wrapLabel}
          />
        </div>
      ))}
    </>
  )
}

const propTypes = {
  activeSearch: PropTypes.bool,
  buttonIsGrayWithNoInput: PropTypes.bool,
  categories: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  dealsDontMove: PropTypes.bool,
  header: PropTypes.string,
  hideCloseIcon: PropTypes.bool,
  largeCategoryHeader: PropTypes.bool,
  priceGuidanceNewLabelStyle: PropTypes.bool,
  searchFilterFontSize: PropTypes.string,
  showChip: PropTypes.bool,
  showDivider: PropTypes.bool,
  showLeftRail: PropTypes.bool,
  showSearchIconButton: PropTypes.bool,
  sopqLearnMore: PropTypes.string,
  sopqProps: PropTypes.object,
  textCollapsed: PropTypes.string,
  textExpanded: PropTypes.string,
}

const defaultProps = {
  largeCategoryHeader: false,
  showDivider: true,
}

FiltersSection.propTypes = propTypes
FiltersSection.defaultProps = defaultProps

export default FiltersSection
